
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiThreewayStackedClosedRight as ObiThreewayStackedClosedRightElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-threeway-stacked-closed-right.js';
 
 
 

 
 export const ObiThreewayStackedClosedRight = createComponent({
   react: React,
   tagName: 'obi-threeway-stacked-closed-right',
   elementClass: ObiThreewayStackedClosedRightElement,
   events: {
     
   }
  });
 
 